import axios from "axios";
import i18n from "../i18n";
import { twentyFourHoursInMs } from "../global";
import { useQuery } from "@tanstack/react-query";

const {
  REACT_APP_BASE_URL,
  REACT_APP_GET_ABOUT_US,
  REACT_APP_GET_ALL_SERVICES,
  REACT_APP_GET_SUBSCRIPTION_PLANS,
  REACT_APP_GET_PUBLIC_NOTICES,
  REACT_APP_GET_HOME_STATS,
  REACT_APP_GET_SEO,
  REACT_APP_GET_TERMS,
  REACT_APP_GET_POLICY,
} = process.env;

export const fetchServices = (lng) => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_ALL_SERVICES + lng);
};

export const fetchAbout = (lng) => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_ABOUT_US + lng);
};

export const fetchSubscription = (lng) => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_SUBSCRIPTION_PLANS + lng);
};

export const fetchPublicNotices = (token) => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_PUBLIC_NOTICES, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const fetchHomeStats = (lng) => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_HOME_STATS + lng);
};

export const fetchSeo = () => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_SEO);
};

export const fetchTerms = () => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_TERMS + i18n.language);
};

export const fetchPolicy = () => {
  return axios.get(REACT_APP_BASE_URL + REACT_APP_GET_POLICY + i18n.language);
};

export const useAbout = () => {
  return useQuery({
    queryKey: ["aboutus", i18n.language],
    queryFn: () => fetchAbout(i18n.language),
    staleTime: twentyFourHoursInMs,
  });
};

export const useServices = () => {
  return useQuery({
    queryKey: ["services", i18n.language],
    queryFn: () => fetchServices(i18n.language),
    staleTime: twentyFourHoursInMs,
  });
};

export const useSubscription = () => {
  return useQuery({
    queryKey: ["subscription", i18n.language],
    queryFn: () => fetchSubscription(i18n.language),
    staleTime: twentyFourHoursInMs,
  });
};

export const usePublicNotices = () => {
  return useQuery({
    queryKey: ["publicNotices"],
    queryFn:
      localStorage.getItem("uts") !== null
        ? () => fetchPublicNotices(localStorage.getItem("uts"))
        : null,
    staleTime: twentyFourHoursInMs,
  });
};

export const useHomeStats = () => {
  return useQuery({
    queryKey: ["homeStats", i18n.language],
    queryFn: () => fetchHomeStats(i18n.language),
    staleTime: twentyFourHoursInMs,
  });
};

export const useSeo = () => {
  return useQuery({
    queryKey: ["seo", i18n.language],
    queryFn: () => fetchSeo(),
    staleTime: twentyFourHoursInMs,
  });
};

export const useTerms = () => {
  return useQuery({
    queryKey: ["terms", i18n.language],
    queryFn: () => fetchTerms(),
    staleTime: twentyFourHoursInMs,
  });
};

export const usePolicy = () => {
  return useQuery({
    queryKey: ["policy", i18n.language],
    queryFn: () => fetchPolicy(),
    staleTime: twentyFourHoursInMs,
  });
};
